import { createContext, useContext } from "react";

const BreadcrumbToolbarContext = createContext<HTMLElement | null>(null);

export const BreadcrumbToolbarProvider = BreadcrumbToolbarContext.Provider;

export const useBreadcrumbToolbarContainer = () => useContext(BreadcrumbToolbarContext);
